import React from 'react'

import { Trash2Icon } from 'lucide-react'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { HASH_SYMBOL } from '~/client/src/shared/utils/usefulStrings'

import CalendarLinkInputStore from '../CalendarLinkInput.store'

interface IProps {
  store: CalendarLinkInputStore
}

@observer
export default class CalendarSubscriptions extends React.Component<IProps> {
  public render(): JSX.Element {
    const { subscriptions } = this.store

    if (!subscriptions?.length) {
      return (
        <div className="text grey small px30 mt30">
          {Localization.translator.youDontHaveAnySubscriptionsYet}
        </div>
      )
    }

    return (
      <div className="col y-center setup-form-parameter mt20 px30 text bold full-width">
        <div className="text grey small mb40">
          {Localization.translator.youSubscribedToNExternalProjects(
            subscriptions.length,
          )}
        </div>
        {this.renderSubscriptionsTable()}
      </div>
    )
  }

  private renderSubscriptionsTable(): JSX.Element {
    return (
      <div className="col subscriptions-table">
        <div className="row text bold pb10 bb-light-input-border">
          <div className="number-column text small primary">{HASH_SYMBOL}</div>
          <div className="name-column text small primary">
            {Localization.translator.sharedProjectName}
          </div>
          <div className="link-column text small primary">
            {Localization.translator.inviteLink}
          </div>
          <div className="visibility-column text small primary">
            {Localization.translator.visibility}
          </div>
        </div>
        {this.store.subscriptions.map((subscription, index) => (
          <div
            key={subscription.id}
            className="row py5 border-bottom bb-light-input-border"
          >
            <div className="number-column text">{index + 1}.</div>
            <div className="name-column text">
              {subscription.tenantCalendarEndpoint.split('/').at(-2)}
            </div>
            <div className="link-column text row">
              <div className="text ellipsis mw220">
                {subscription.tenantCalendarEndpoint}
              </div>
              <Button
                variant="primary-outline"
                className="ml10 mb4"
                onClick={() =>
                  this.store.copyLinkToClipboard(
                    subscription.tenantCalendarEndpoint,
                  )
                }
              >
                {Localization.translator.copy}
              </Button>
            </div>
            <div className="visibility-column text">
              <div className="tw:flex tw:items-center">
                <Button
                  variant="destructive-ghost"
                  size="icon"
                  aria-label={Localization.translator.deleteSubscription}
                  onClick={() =>
                    this.store.setIsRemoveSubscriptionDialogShown(
                      true,
                      subscription.id,
                    )
                  }
                >
                  <Trash2Icon />
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  private get store(): CalendarLinkInputStore {
    return this.props.store
  }
}
